import * as bootstrap from 'bootstrap';
import IMask from 'imask';
import TomSelect from 'tom-select';
import flatpickr from "flatpickr";
import { Dutch } from "flatpickr/dist/l10n/nl.js"
import Helper from './helper';

flatpickr.localize(Dutch);
window.flatpickr = flatpickr;

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.honeyForms();
        this.cookies();
        this.iMask();
        this.initTomSelect();
    }

    /**
     * Honey pot protection for forms
     */
    honeyForms() {
        // Initialize honey pot for a single form
        const initHoneyForm = (form) => {
            // Skip if already initialized
            if (form.dataset.honeyInitialized === 'true') {
                return;
            }

            // Mark as initialized
            form.dataset.honeyInitialized = 'true';

            // Randomize delay between 4-6 seconds to be less predictable
            const delay = 4000 + Math.random() * 2000;

            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    const originalText = buttonSubmit.getAttribute('data-text');

                    if (originalText) {
                        buttonSubmit.innerHTML = originalText;
                        buttonSubmit.disabled = false;
                    }
                }

                let coffeeCup = form.querySelector('.coffee-cup');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';

                    // For Livewire-bound fields, trigger input event to sync with wire:model
                    if (coffeeCup.hasAttribute('wire:model') || coffeeCup.hasAttribute('wire:model.defer')) {
                        coffeeCup.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }, delay);
        };

        // Initialize all existing honey forms
        document.querySelectorAll('.form--honey').forEach(form => {
            initHoneyForm(form);
        });

        // Watch for dynamically added forms
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // Check if the added node is a form with honey class
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('form--honey')) {
                            initHoneyForm(node);
                        }

                        // Also check for honey forms within the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.form--honey').forEach(form => {
                                initHoneyForm(form);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    iMask(container = document) {
        container.querySelectorAll('[data-mask="date"]').forEach(element => {
            IMask(element, {
                mask: '00-00-0000'
            });
        });

        container.querySelectorAll('[data-mask="tel"]').forEach(element => {
            IMask(element, {
                mask: /^[0-9-]*$/
            });
        });
    }

    /**
     * Initialize TomSelect dropdowns
     */
    initTomSelect() {
        document.querySelectorAll('select.tom-select').forEach(element => {
            new TomSelect(element, {
                placeholder: 'Selecteer een programma',
                render: {
                    option: (data, escape) => {

                        const name = data.name || data.text;
                        const locations = data.locations || '';
                        const spots = data.spots || '';

                        let dates = [];

                        try {
                            dates = JSON.parse(data.dates || '[]');
                        } catch (e) {
                            dates = [];
                        }

                        let html = '<div class="ts-program-option">';
                        html += '<span class="ts-program-name">' + escape(name) + '</span>';

                        if (spots) {
                            html += '<span class="ts-program-detail"><i class="fa-regular fa-users"></i> ' + escape(spots) + '</span>';
                        }

                        if (locations) {
                            html += '<span class="ts-program-detail"><i class="fa-regular fa-location-dot"></i> ' + escape(locations) + '</span>';
                        }

                        if (dates.length > 0) {
                            html += '<div class="ts-program-dates">';
                            html += '<i class="fa-regular fa-calendar"></i>';
                            html += '<div class="ts-program-dates-list">';

                            dates.forEach((date) => {
                                html += '<span>' + escape(date) + '</span>';
                            });

                            html += '</div>';
                            html += '</div>';
                        }

                        html += '</div>';

                        return html;
                    },
                    item: (data, escape) => {

                        const name = data.name || data.text;

                        let dates = [];

                        try {
                            dates = JSON.parse(data.dates || '[]');
                        } catch (e) {
                            dates = [];
                        }

                        let label = name;

                        if (dates.length > 0) {
                            label += ' — ' + dates[0];
                        }

                        return '<div>' + escape(label) + '</div>';
                    }
                }
            });
        });
    }


    /**
     * Initialize the date picker plugin
     */
    initDatePicker (container = document) {
        // Initialize date picker
        container.querySelectorAll('.datepicker').forEach(input => {
            let defaultDate = null;

            if (input.value.length) {
                // Split the string into parts
                let dateParts = input.value.split('-');

                // Use the parts to create a Date object
                defaultDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
            }

            // Initialize flatpickr
            flatpickr(input, {
                defaultDate: defaultDate,
                dateFormat: 'd-m-Y',
                allowInput: false,
                locale: Dutch
            });
        });
    }
}

window.addEventListener('load', () => new App());
